import { Pipe, PipeTransform } from "@angular/core";
import { I18nPipe } from "./i18n.pipe";

@Pipe({
    name: "i18nRequiredField",
    pure: false // required to update the value when the promise is resolved
    ,
    standalone: false
})
export class I18nRequiredFieldPipe extends I18nPipe implements PipeTransform {
  /**
   * #### Description
   * Simple pipe for fast "Require" message - key 'form.error.required' will be used.
   * Can be used instead of {{ 'form.error.required' | i18n:{field: 'step_details_responsible' | i18n } }}
   * #### Example
   *  'step_details_responsible' | i18nRequiredField
   *
   * Transforms i18n required field pipe
   * @param value Translation key
   * @param args
   * @returns transform
   */
  public transform(value: unknown, ...args: unknown[]): unknown {
    const field = super.transform(value as string, ...args);
    return super.transform("form.error.required", { field }, ...args);
  }
}
